import { SensitiveType, sensitiveTypeValidator } from '@framework/engine';
import { yup } from '@framework/validation';

export const OmissisDirectiveSchema: yup.ObjectSchema<IOmissisDirective> = yup
  .object({
    enabled: yup
      .boolean()
      .required()
      /** NB Di default un campo è _incluso_ e _visibile_ (non omissis) **/
      .default(false)
      .label('Abilita omissis'),
    sensitiveType: sensitiveTypeValidator.nonNullable(),
  })
  .noUnknown();

export interface IOmissisDirective {
  enabled: boolean;
  /**
   * Tipo di dati sensibili del campo: sensibili | personali | nessuno
   */
  sensitiveType?: SensitiveType;
}
